const wrapInApiUrl = (path) => {
  return `${process.env.GATSBY_SERVER_URL}/${path}`
}

export default wrapInApiUrl
